import { FC, memo } from 'react'
import { useRouter } from 'next/router'
import { HeaderSectionTransport } from '../../../transports/region-landing-page-transport'
import useSearchbarState from '../../../hooks/searchbar-state'
import ControlledSearchbar from '../controlled-searchbar'
import { SearchbarMode } from '../../search-result-listing/header-section/types'
import SearchRegionNodeTransport from '../../../transports/search-region-node-transport'
import { PageSubType } from '../../../constants/booking-page-type'

type Navigation = HeaderSectionTransport['navigationSectionResponse']['navigation']

interface HeroSearchbarProps {
    initialLocation?: string
    logo?: Navigation['logo']
    isSticky?: boolean
    petsAllowed?: boolean
    maxWidth?: string
    searchbarMode?: SearchbarMode
    searchRegionNode?: SearchRegionNodeTransport | null
    pageSubType?: PageSubType
    isBorderGradientEnabled?: boolean
}

const HeroSearchbar: FC<HeroSearchbarProps> = ({
    initialLocation,
    logo,
    isSticky,
    petsAllowed = false,
    maxWidth,
    searchbarMode = SearchbarMode.MAIN,
    searchRegionNode = null,
    pageSubType,
    isBorderGradientEnabled,
}) => {
    const { query } = useRouter()

    const {
        searchbar,
        locationValue,
        onLocationChange,
        onArrivalDateChange,
        onDepartureDateChange,
        onAdultsCountChange,
        onChildrenCountChange,
    } = useSearchbarState({ query, location: initialLocation, searchRegionNode })

    return (
        <ControlledSearchbar
            location={locationValue}
            arrivalDate={searchbar.arrival}
            departureDate={searchbar.departure}
            adultsCount={searchbar.adults}
            childrenCount={searchbar.kids}
            onLocationChange={onLocationChange}
            onArrivalDateChange={onArrivalDateChange}
            onDepartureDateChange={onDepartureDateChange}
            onAdultsCountChange={onAdultsCountChange}
            onChildrenCountChange={onChildrenCountChange}
            petsAllowed={petsAllowed}
            isSticky={isSticky}
            logo={logo}
            maxWidth={maxWidth}
            searchbarMode={searchbarMode}
            pageSubType={pageSubType}
            isBorderGradientEnabled={isBorderGradientEnabled}
        />
    )
}

export default memo(HeroSearchbar)
